var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "comm_sider fnt_30"
  }, [_c('ul', {
    staticClass: "fixed"
  }, [_c('li', {
    on: {
      "click": _vm.serviceClick
    }
  }, [_vm._m(0), _c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v("客服")])]), _c('li', {
    ref: "cartIcon",
    staticClass: "has-badge",
    on: {
      "click": _vm.shoppingCartClick
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "icon-gouwuche"
  }), _vm.cartCount > 0 ? _c('div', {
    staticClass: "badge",
    class: {
      shaking: _vm.isShake
    }
  }, [_vm._v(" " + _vm._s(_vm.cartCount) + " ")]) : _vm._e()]), _c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v("购物车")])]), _c('li', {
    on: {
      "click": _vm.quickOrderClick
    }
  }, [_vm._m(1), _c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v("快速订购")])]), _c('li', {
    on: {
      "click": _vm.myComparisonClick
    }
  }, [_vm._m(2), _c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v("对比")])]), _c('li', {
    on: {
      "click": _vm.scrollToTop
    }
  }, [_vm._m(3), _c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v("返回顶部")])])])]), _vm.showFlyBall ? _c('div', {
    staticClass: "fly-ball",
    style: {
      left: _vm.flyX + 'px',
      top: _vm.flyY + 'px',
      opacity: _vm.flyOpacity
    }
  }, [_c('i', {
    staticClass: "el-icon-shopping-cart-2"
  })]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "icon-kefu"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "icon-dinggoufushu"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "icon-duibi"
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "toTop",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "icon-fanhuidingbu-"
  })]);
}]

export { render, staticRenderFns }